(function($, window, document) {
  var $doc = $(document),
  $win = $(window);
  
  var $html = $('html'),
  $body = $('body');
  
  objectFitImages();
  
  AOS.init({
    once: true
  });
  
  //
  // Booking
  //
  $('[data-booking-form]').booking({
    checkinSelector: '[name="checkin"]',
    checkoutSelector: '[name="checkout"]',
    adultSelector: '[name="numofadult"]',
    childSelector: '[name="numofchild"]',
    roomSelector: '[name="numofroom"]',
    codeSelector: '[name="accesscode"]',
    propertyId: 577,
    builtinDatepicker: {
      enable: false,
    }
  });
  
  var $checkin = $('.js-datepicker-checkin');
  var $checkout = $('.js-datepicker-checkout');
  var $checkin_hid = $('[data-booking-form]').find('[name=checkin]');
  var $checkout_hid = $('[data-booking-form]').find('[name=checkout]');
  
  var today = new Date();
  var tomorrow = nextDay(today, 1);
  
  // Delay init to wait default settings from WordPress
  setTimeout(function() {
    $checkin.datepicker({
      minDate: '0',
      altFormat: 'd M yy',
      altField: '#ui_checkin',
      dateFormat: 'yy-mm-dd',
      onSelect: function( date ) {
        $checkin_hid.val( date );
        
        $checkout.datepicker('option', 'minDate', nextDay(date, 1));
        var checkoutDate = $checkout.datepicker('getDate');
        $checkout_hid.val( moment(checkoutDate).format('YYYY-MM-DD') );
        
        checkinDatepicker('hide');
        checkoutDatepicker('show');
      }
    });
    
    $checkout.datepicker({
      minDate: '+1',
      altFormat: 'd M yy',
      altField: '#ui_checkout',
      dateFormat: 'yy-mm-dd',
      onSelect: function( date ) {
        $checkout_hid.val( date );
        
        checkoutDatepicker('hide');
      },
    });
    
    $checkin_hid.val( moment(today).format('YYYY-MM-DD') );
    $checkout_hid.val( moment(tomorrow).format('YYYY-MM-DD') );
  }, 500);
  
  function nextDay( date, numofday ) {
    var day = numofday * 24 * 60 * 60 * 1000;
    var date = new Date(date).getTime();
    var next = new Date(date + day);
    return next;
  }
  
  $('[data-booking-panel]').each(function(i, el) {
    var _this   = el;
    var $panel  = $('.panel-booking');
    $(_this).on('click', function(event) {
      event.preventDefault();
      var option  = _this.dataset.bookingPanel;
      var methods = {
        show: function() {
          $panel.addClass('show');
        },
        hide: function() {
          $panel.removeClass('show');
        },
        toggle: function() {
          if (this.state() === 'show')
          this.hide();
          else
          this.show();
        },
        state: function() {
          var state = ($panel.hasClass('show')) ? 'show' : 'hide';
          return state;
        }
      }
      return methods[option]();
    });
  });
  
  $doc.on('click', function(event) {
    var target = event.target;
    if (
      !$(target).closest('.panel-booking, [data-booking-panel]').length &&
      !$(target).closest('.ui-datepicker').length &&
      !$(target).is('.ui-datepicker-prev') &&
      !$(target).is('.ui-datepicker-next')
      ) {
        $('.panel-booking').removeClass('show');
        $('#checkin, #checkout').datepicker('hide');
      }
    });
    
    //
    // Datepicker Panel
    //
    $('#ui_checkin').on('click', function() {
      checkinDatepicker('toggle');
    });
    
    $('#ui_checkout').on('click', function() {
      checkoutDatepicker('toggle');
    });
    
    $doc.on('click', function(event) {
      var target = event.target;
      var except = '.ui-datepicker-next, .ui-datepicker-prev';
      
      if (
        !$(target).closest('.js-datepicker-checkin, #ui_checkin').length > 0 &&
        !$(target).is(except)
        ) {
          $('.js-datepicker-checkin').removeClass('is-show');
        }
        
        if (
          !$(target).closest('.js-datepicker-checkout, #ui_checkout').length > 0 &&
          !$(target).is(except)
          ) {
            $('.js-datepicker-checkout').removeClass('is-show');
          }
        });
        
        var offsetCalendar = function offsetCalendar(el) {
          var win = {
            w: window.innerWidth
          };
          var cal = {
            right: $(el).offset().left + $(el).width()
          };
          var offset = 17;
          
          if (win.w < cal.right) {
            $(el).css('left', win.w - cal.right - offset + 'px');
            var arrowOF = cal.right - win.w + offset;
            $(el).find('.arrow').css('left', '+=' + arrowOF);
          }
        };
        
        $(window).on('load', function () {
          offsetCalendar($checkout);
        });
        
        function checkinDatepicker(method) {
          var methods = {
            show: function() {
              $checkin.addClass('is-show');
            },
            hide: function() {
              $checkin.removeClass('is-show');
            },
            toggle: function() {
              if ($checkin.hasClass('is-show')) {
                this.hide();
              } else {
                this.show();
              }
            }
          }
          
          return methods[method]();
        }
        
        function checkoutDatepicker(method) {
          var methods = {
            show: function() {
              offsetCalendar($checkout);
              $checkout.addClass('is-show');
            },
            hide: function() {
              $checkout.removeClass('is-show');
            },
            toggle: function() {
              if ($checkout.hasClass('is-show')) {
                this.hide();
              } else {
                this.show();
              }
            }
          }
          
          return methods[method]();
        }
        
        //
        // PreventDefault
        //
        $doc.on('click', '.preventdefault', function(event) {
          event.preventDefault();
        });
        
        //
        // Instagram Gallery
        //
        $('[data-instagram-gallery]').each(function() {
          $(this).instagramGallery({
            token: '1929790421.1677ed0.c0669e08316a42109d12d8c92d57518f',
            complete: function($el) {
              $el.photoSwipe();
            }
          });
        });
        
        //
        // WordPress Gallery
        //
        $('.gallery').each(function() {
          var $el = $(this);
          if ($el.find('a > img').length > 0) {
            $el.magnificPopup({
              delegate: 'a',
              type: 'image',
              gallery: {
                enabled: true,
              },
              mainClass: 'mfp-fade',
              removalDelay: 150,
            });
          }
        });
        
        //
        // Side Menu
        //
        function sideMenu(methods) {
          switch (methods) {
            case 'show':
            $body.addClass('side-panel-show');
            break;
            case 'hide':
            $body.removeClass('side-panel-show');
            break;
          }
        }
        
        $('.drag-panel').swipe({
          swipeRight: function() {
            sideMenu('show');
          }
        });
        
        $('.side-panel-bg').swipe({
          swipeLeft: function() {
            sideMenu('hide');
          }
        });
        
        $('.side-panel-trigger').on('click', function(event) {
          event.preventDefault();
          sideMenu('show');
        });
        
        $('.side-panel-bg').on('click', function(event) {
          event.preventDefault();
          sideMenu('hide');
        });
        
        $win.on('resize', $.debounce(150, function() {
          if (window.innerWidth >= 992)
          sideMenu('hide');
        }));
        
        //
        // Mobile Bottom Checker
        //
        if ($('.mobile-bottom').length) {
          $body.addClass('has-mobile-bottom');
        }
        
        //
        // Carousel
        //
        $('[data-carousel]').each(function() {
          var moreThanOne = ($(this).find('.swiper-slide').length > 1) ? true : false;
          var slide = new Swiper(this, {
            loop: moreThanOne,
            spaceBetween: 10,
            speed: 600,
            grabCursor: moreThanOne,
            simulateTouch: moreThanOne,
            allowTouchMove: moreThanOne,
            navigation: {
              nextEl: '.swiper-custom-next',
              prevEl: '.swiper-custom-prev'
            },
            on: {
              init: function() {
                if (!moreThanOne) this.$el.addClass('is-single-item');
              }
            }
          });
        });
        
        // Hero Carousel
        $('.hero-carousel').each(function() {
          var moreThanOne = ($(this).find('.swiper-slide').length > 1) ? true : false;
          var slide = new Swiper(this, {
            loop: moreThanOne,
            speed: 600,
            simulateTouch: moreThanOne,
            allowTouchMove: moreThanOne,
            effect: 'fade',
            fadeEffect: {
              crossFade: true
            },
            autoplay: {
              delay: 5000,
            },
            pagination: {
              el: (moreThanOne) ? '.swiper-pagination' : '',
              type: 'bullets',
              clickable: true
            },
            navigation: {
              prevEl: '.swiper-custom-prev',
              nextEl: '.swiper-custom-next'
            }
          });
        });
        
        // Room Carousel
        $('.room-carousel').each(function() {
          var moreThanOne = ($(this).find('.swiper-slide').length > 1) ? true : false;
          var slide = new Swiper(this, {
            loop: moreThanOne,
            speed: 600,
            grabCursor: moreThanOne,
            simulateTouch: moreThanOne,
            allowTouchMove: moreThanOne,
            effect: 'fade',
            fadeEffect: {
              crossFade: true
            },
            autoplay: {
              delay: 5000
            },
            on: {
              slideChange: function() {
                var i = this.realIndex;
                $('.room-carousel-nav .list-rooms li').eq(i).addClass('active').siblings().removeClass('active');
              }
            }
          });
        });
        
        $('.room-carousel-nav .list-rooms').on('click', 'li', function(event) {
          event.preventDefault();
          var i = $(this).index() + 1;
          $('.room-carousel').get(0).swiper.slideTo(i);
        });
        
        $('#toggle_room_content').on('click', function() {
          if (roomContent()) {
            roomContent('hide');
          } else {
            roomContent('show');
          }
        });
        
        $('#hide_room_content').on('click', function() {
          roomContent('hide');
        });
        
        function roomContent(methods) {
          switch (methods) {
            case 'show':
            $body.removeClass('room-content-hide');
            break;
            case 'hide':
            $body.addClass('room-content-hide');
            break;
            default:
            return !$body.hasClass('room-content-hide');
            break;
          }
        }
        
        // Location Carousel
        var $map = $('[data-carousel-map]');
        var $nav = $('[data-carousel-map-nav]');
        
        $map.each(function() {
          var slide = new Swiper(this, {
            loop: false,
            speed: 600,
            effect: 'fade',
            fadeEffect: {
              crossFade: true
            },
            on: {
              init: function() {
                var idx = this.realIndex;
                $nav.find('li').eq(idx).find('a').addClass('active');
              },
              slideChange: function() {
                var idx  = this.realIndex;
                var $btn = $nav.find('li').eq(idx).find('a');
                $btn.addClass('active');
                $btn.parent().siblings().children('a').removeClass('active');
              }
            }
          });
        });
        
        $nav.on('click', 'a', function(event) {
          event.preventDefault();
          var instance = $map.get(0).swiper;
          var idx = $(this).parent().index();
          instance.slideTo(idx);
        });
        
        $win.on('resize', $.throttle(16, function() {
          var contWidth = $nav.width();
          var itemsWidth = 0;
          $nav.find('li').each(function() {
            itemsWidth += Math.round($(this).outerWidth(true));
          });
          if (itemsWidth > contWidth)
          $nav.addClass('responsive');
          else
          $nav.removeClass('responsive');
        }));
        
        //
        // Parallax Background
        //
        $.fn.parallaxBackground = function(options) {
          var defaults = {
            item: '.parallax-bg'
          }
          
          var config = $.extend(defaults, options);
          
          return this.each(function() {
            var el = this;
            var winHeight, height, top, start, stop, duration, move;
            
            var src = $(el).find(config.item).data('parallaxBg');
            $(el).find(config.item).css({
              backgroundImage: 'url('+src+')',
              backgroundSize: 'cover',
              opacity: 0,
            });
            
            update();
            
            $win.on('scroll resize load', $.throttle(16, function(event) {
              var pos = 0;
              var winY = window.scrollY;
              if (winY >= start && winY < stop) {
                pos = ((winY - start) / move).toFixed(2);
                
                $(el).find(config.item).css({
                  '-ms-transform': 'translate(0, '+pos+'px)',
                  'transform': 'translate(0, '+pos+'px)',
                  'transform': 'translate3d(0, '+pos+'px, 0)'
                });
              }
            }));
            
            $win.on('resize', $.debounce(150, function() {
              update();
            }));
            
            $win.on('load', function() {
              $(el).find(config.item).css('opacity', 1);
            });
            
            function update() {
              winHeight   = window.innerHeight;
              height      = $(el).outerHeight();
              top         = $(el).offset().top;
              start       = top - winHeight;
              stop        = top + height;
              duration    = stop - start;
              move        = Math.ceil(duration / height);
            }
          });
        }
        
        $('.parallax-container').parallaxBackground();
        
        //
        // Room Select Dropdown
        //
        $('.room-select .select-display').on('click', function(event) {
          event.preventDefault();
          $(this).toggleClass('show');
        });
        
        $doc.on('click', function(event) {
          var target = event.target;
          if (!$(target).closest('.room-select').length) {
            $('.room-select .select-display').removeClass('show');
          }
        });
        
        //
        // MagnificPopup
        //
        $('[data-mfp-gallery]').each(function() {
          $(this).magnificPopup({
            type: 'image',
            delegate: 'a',
            gallery: {
              enabled: true,
            }
          });
        });
        
        $('[data-mfp-iframe]').each(function() {
          $(this).magnificPopup({
            type: 'iframe',
            mainClass: 'mfp-fade',
            removalDelay: 150,
          });
        });
        
        $('[data-mfp-inline]').each(function() {
          $(this).magnificPopup({
            type: 'inline',
            mainClass: 'mfp-fade',
            removalDelay: 150,
          })
        });
        
        //
        // Gallery with Filter
        //
        var $category = $('[data-gallery-filter-tab]');
        var $gallery = $('[data-gallery-filter-content]');
        
        initGalleryLayout();
        initGalleryFilter();
        
        $category.on('click', 'a', function() {
          var filter = this.dataset.filter;
          initGalleryLayout(filter);
          initGalleryFilter(filter);
        });
        
        $gallery.find('img').each(function() {
          var $img = $(this);
          $img.imagesLoaded().progress(function() {
            $img.addClass('loaded');
            $gallery.isotope('layout');
          });
        });
        
        function initGalleryLayout(filter) {
          var f = filter || '*';
          $gallery.isotope({
            filter: f,
          });
        }
        
        function initGalleryFilter(filter) {
          var f = filter || '*';
          return $gallery.magnificPopup({
            delegate: f +'> a',
            type: 'image',
            gallery: {
              'enabled': true
            },
            mainClass: 'mfp-fade',
            removalDelay: 350
          });
        }
        
        //
        // Background Loader
        //
        $('[data-bg]').each(function() {
          if (this.dataset.bg===undefined)
          return false;
          
          var src = this.dataset.bg;
          var pos = this.dataset.bgPosition || 'center';
          var att = this.dataset.bgAttachment || 'scroll';
          var siz = this.dataset.bgSize || 'cover';
          $(this).css({
            backgroundImage: 'url('+src+')',
            backgroundPosition: pos,
            backgroundAttachment: att,
            backgroundSize: siz,
          });
        });
        
        //
        // Animate Anchor
        //
        $('[data-anchor]').on('click', event => {
          event.preventDefault();
          
          var hash = event.currentTarget.dataset.anchor;
          if ($(hash).length > 0) {
            var trigger = $(hash).offset().top;
            var offset = () => {
              var offset = 0;
              if ( $('#wpadminbar').css('position')==='fixed' ) {
                offset += $('#wpadminbar').outerHeight();
              }
              if ( $('.site-header').css('position')==='fixed' ) {
                offset += $('.site-header').outerHeight();
              }
              return offset;
            }
            
            window.scroll({
              behavior: 'smooth',
              top: trigger - offset()
            });
          }
        });
        
        //
        // Local Information
        //
        
        // Local Temperature
        $('[data-temp]').each(function() {
          var $this = $(this);
          var unit = this.dataset.temp;
          if (unit === undefined)
          console.error('data-temp attribute, unit is required');
          
          $.simpleWeather({
            location: 'Siem Reap,Cambodia',
            unit: unit,
            success: function(weather) {
              var html = weather.temp + '&deg' + weather.units.temp;
              $this.html(html);
            }
          });
        });
        
        // Local Time
        $('[data-time]').each(function() {
          setInterval(() => {
            var now = moment();
            var tz = now.tz('Asia/Bangkok');
            var fmt = tz.format('hh:mm A');
            $(this).html(fmt);
          }, 1000)
        });
        
        //
        // Caption
        //
        $('.js-caption').dotdotdot({
          height: (14*1.5)*3,
        });
        
        //
        // Contact Form
        //
        var $ctf = $('#form_contact');
        if ($ctf.length) {
          $.validate({
            form: $ctf,
            modules: 'html5, location',
            onModulesLoaded: function() {
              $ctf.find('[name="country"]').suggestCountry();
            },
            onSuccess: function($form) {
              var checker = $form.find('.g-recaptcha').get(0);
              grecaptcha.execute(checker.dataset.index);
              return false;
            }
          });
          
          $.fn.contactForm = function() {
            var $form       = $(this);
            var _form       = $form[0];
            var $result     = $form.find('.form-result');
            var formData    = $form.serializeArray();
            var url         = _form.baseURI;
            
            appendData(formData, 'url', url);
            appendData(formData, 'action', 'contact_us');
            
            console.log(formData);
            
            var postData = $.post({
              url: local.ajaxurl,
              data: formData,
              beforeSend: function() {
                clearResult();
                $form.addClass('sending');
              },
            });
            
            postData.done(function(response) {
              var msg = response.data.message;
              if (!response.success) {
                showResult('warning', msg);
              } else {
                showResult('success', msg);
                _form.reset();
              }
            });
            
            postData.fail(function(jqXHR) {
              console.log(jqXHR);
              showResult('warning', 'Message cannot be sent. Please contact directly to <a class="alert-link" href="mailto:info@viroth-villa.com">info@viroth-villa.com</a> <br/>We apologize for any inconvenience.');
            });
            
            postData.always(function() {
              grecaptcha.reset();
              $form.removeClass('sending');
            });
            
            function appendData(dataArr, name, value) {
              return dataArr.push({
                name: name,
                value: value,
              });
            }
            
            function showResult(status, msg) {
              return $result.addClass('alert alert-'+status).html(msg).show();
            }
            
            function clearResult() {
              return $result.removeClass('alert-success alert-warning').empty().hide();
            }
          };
        }
        
        //
        // Offer, Subscribe Form
        //
        $('#form_subscribe, #form_offers').on('submit', function() {
          event.preventDefault();
          var $form = $(this);
          var _form = $form[0];
          var email = $form.find('[name=email]').val();
          var formData = $form.serializeArray();
          var params = new Object()
          formData.forEach(el => {
              params[el.name] = el.value
          })
          $.post({
            url: 'https://hotelservices.travelanium.net/crs-customer-form-rs/restresources/CRSCustomerFormDataService',
            data: JSON.stringify({
              formKey: '17ba530eac1200050b6f72cad2fc8673',
              email: email
            }),
            contentType: 'application/json',
            error: function(jqXHR) {
              console.log(jqXHR);
          },
          });

          $.post({
            url: local.ajaxurl,
            data: params,
            beforeSend(res) {
              $form.addClass('sending');
            },
            success(res) {
              if (res.success) {
                showResult('success', 'Subscription Successful');
                _form.reset();
              } else {
                showResult('warning', 'Subscription Error');    
              }
            },
            error(jqXHR) {
              console.log(jqXHR);
              showResult('warning', 'Ajax error: ('+jqXHR.status+'), Please try again later.');
            },
            complete() {
                $form.removeClass('sending');
            }
          });
          
          function showResult(status, msg) {
            return $.magnificPopup.open({
              items: {
                src: '<div class="mx-auto mw-576 alert alert-'+status+'">'+msg+'</div>',
                type: 'inline',
              }
            });
          }
          
          return false;
        });
      })(jQuery, window, document);